import ClientPortalAPIService from '../services/api/ClientPortal/ApiService'
import User from './user'

export class AirportModule {
    airports = []
    isFetchingAirports = true

    constructor() {}

    initialize() {
        ClientPortalAPIService.getAirports().then(airportsData => {
            this.airports = airportsData
        }).finally(() => {
            this.isFetchingAirports = false
        })
    }

    async getModuleReadyStatus() {
        const readyStatusPromise = await new Promise((resolve) => {
            const observerInterval = window.setInterval(() => {
                if (!this.isFetchingAirports) {
                    resolve(true)
                    window.clearInterval(observerInterval)
                }
            }, 25)
        }) 

        return readyStatusPromise
    }

    async getModuleAirports() {
        const airports = await new Promise((resolve) => {
            const observerInterval = window.setInterval(() => {
                if (!this.isFetchingAirports) {
                    resolve(this.airports)
                    window.clearInterval(observerInterval)
                }
            }, 25)
        }) 

        return airports
    }

    getAirportByIATACode(IATACode) {
        return this.airports.find(airport => airport.IATA === IATACode)
    }
    
    getAirportByICAOCode(ICAOCode) {
        return this.airports.find(airport => airport.ICAO === ICAOCode)
    }

    // This function doesn't make sense to be on the user level, as some user don't have anything to do with airports
    // So here seems to be the best place. Basically this function will accept an ICAO code of an airport (since all airports have ICAO code)
    // and return the airport code based on the user airport code preferences or ICAO code if the airport doens't have any IATA code
    getUserPreferredAirportCode(ICAOCode) {
        const airport = this.getAirportByICAOCode(ICAOCode)
        return User.userSettings.airportCode === 'ICAO' ? airport.ICAO : (!!airport.IATA ? airport.IATA : airport.ICAO)
    }
}

const Airport = new AirportModule()
export default Airport